<template>
    <div>
       <mu-paper :zDepth="5">
       		<mu-content-block>
       			阴影容器
       		</mu-content-block>
       </mu-paper>
    </div>
</template>
<script>
export default {
    name: 'paper'
}
</script>



// WEBPACK FOOTER //
// paper.vue?01cda3e1